var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.504,
    height: 29.602,
    viewBox: "0 0 23.504 29.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doc",
    transform: "translate(-1.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9793",
    "data-name": "Path 9793",
    d: "M76.239,26.959A2.646,2.646,0,0,1,73.591,29.6H55.383a2.646,2.646,0,0,1-2.648-2.643V2.643A2.646,2.646,0,0,1,55.383,0H66.718a1.988,1.988,0,0,1,1.406.582l7.535,7.536a1.98,1.98,0,0,1,.58,1.4Z",
    transform: "translate(-51.455 0)",
    fill: "#5da9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9796",
    "data-name": "Path 9796",
    d: "M317.357,11.62h-6.729a1.791,1.791,0,0,1-1.79-1.791V3.1a1.968,1.968,0,0,1,.582.4l7.535,7.536a1.968,1.968,0,0,1,.4.581Z",
    transform: "translate(-292.751 -2.922)",
    fill: "#8ec2fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15665",
    "data-name": "Group 15665",
    transform: "translate(6.357 15.193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4490",
    "data-name": "Rectangle 4490",
    width: 12.79,
    height: 1.421,
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4491",
    "data-name": "Rectangle 4491",
    width: 12.79,
    height: 1.421,
    transform: "translate(0 3.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4492",
    "data-name": "Rectangle 4492",
    width: 9.096,
    height: 1.421,
    transform: "translate(0 6.348)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.635c8e1bc1b034a3d0f31bb440892da2.svg";
export { ForwardRef as ReactComponent };